export default __webpack_public_path__ + "static/media/59t.cc2c23fa.jpg";